export const FETCH_INDUSTRY = 'FETCH_INDUSTRY';
export const FETCH_INDUSTRY_SUCCESS = 'FETCH_INDUSTRY_SUCCESS';
export const FETCH_INDUSTRY_FAILURE = 'FETCH_INDUSTRY_FAILURE';

export const FETCH_SUBINDUSTRY = 'FETCH_SUBINDUSTRY';
export const FETCH_SUBINDUSTRY_SUCCESS = 'FETCH_SUBINDUSTRY_SUCCESS';
export const FETCH_SUBINDUSTRY_FAILURE = 'FETCH_SUBINDUSTRY_FAILURE';

export const RESET_META_DATA = 'RESET_META_DATA';

